import React, { useState } from "react";
import { SignUp } from "../components";

const Auth = () => {
  
  const [open, setOpen] = useState(true);
  

  return (
    <div className='w-full '>

      <SignUp open={open} setOpen={setOpen} />
    </div>
  );
};

export default Auth;
